import React from "react";
import ContentLoader from "react-content-loader";
import "./RecurringSmallViews.css";

import waveBackgroundSvg from "./lightWave4xSymmetry.svg";

export function ErrorView(error?: string): JSX.Element {
  return (
    <div className="ErrorDisplay">
      <h2>Error! {error}</h2>
    </div>
  );
}

export function LoadingView(): JSX.Element {
  return (
    <div className="LoadingDisplay">
      <ContentLoader />
    </div>
  );
}

export function CenteringView(inside: JSX.Element): JSX.Element {
  return (
    <div className="CenteringContainer">
      <div className="Centering">{inside}</div>
    </div>
  );
}

export function DesktopCenteringView(inside: JSX.Element): JSX.Element {
  return (
    <div
      className="DesktopCenteringContainer"
      style={{
        backgroundImage: `url(${waveBackgroundSvg})`,
      }}
    >
      <div className="DesktopCenteringView">{inside}</div>
    </div>
  );
}
